// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"DevSecOps_pageContainer__l68eS","approachSection":"DevSecOps_approachSection__6tRYQ"};